import React, { Suspense } from 'react';
import { SearchSelect, Props as SearchSelectProps } from '../Form/Select/SearchSelect';
import { graphql } from '../../generated';
import { useSuspenseQueryAllPages } from '../../model/graphql';
import { Spinner } from '../Spinner/Spinner';
import { t } from '../../locales/translate';

type Props = Omit<SearchSelectProps, 'values'> & {
  shopId: string;
};

const TOUR_SHOP_ARTISTS = graphql(`
  query GetTourShopArtists($shopId: String, $after: String) {
    categories(shopId: $shopId, types: ["Artist"], first: 100, after: $after) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`);

function ArtistSelect$({ shopId, ...rest }: Props): JSX.Element {
  const { data } = useSuspenseQueryAllPages(TOUR_SHOP_ARTISTS, {
    variables: { shopId },
    pageInfoExtractor: (data) => data.categories?.pageInfo,
    mergeResults(previousData, fetchMoreResult) {
      return {
        categories: {
          ...fetchMoreResult.categories,
          nodes: [...previousData.categories.nodes, ...fetchMoreResult.categories.nodes],
        },
      };
    },
  });

  const artists = data.categories.nodes.map((node) => ({
    id: node.id,
    label: node.name,
  }));

  return <SearchSelect {...rest} values={artists} key={shopId} />;
}

export function ArtistSelect(props: Props): JSX.Element {
  return (
    <Suspense fallback={<Spinner color="red" text={t.component.artistSelect.loading} />}>
      <ArtistSelect$ {...props} />
    </Suspense>
  );
}
